import { Component, Input } from '@angular/core';

import { IPreFooter } from './pre-footer.types';
import { SectionService } from 'src/app/shared/services/section.service';

@Component({
  selector: 'nx-pre-footer',
  templateUrl: './pre-footer.component.html',
  styleUrls: ['./pre-footer.component.scss'],
})
export class PreFooterComponent implements IPreFooter {
  constructor(private section: SectionService) {}
  // REQUIRED INPUTS
  @Input() data!: IPreFooter['data'];
}
